import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const END_TYPES = {
  NEVER: 'never',
  COUNT: 'count',
  UNTIL: 'until',
};

export default function PeriodSection({
  endType,
  onEndTypeChange,
  count,
  onCountChange,
  until,
  onUntilChange,
}) {
  const { t } = useTranslation('common');

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" gutterBottom>
          {t('common:rrule.period.title')}
        </Typography>

        <RadioGroup
          value={endType}
          onChange={(e) => onEndTypeChange(e.target.value)}
        >
          {/* No End */}
          <FormControlLabel
            value={END_TYPES.NEVER}
            control={<Radio size="small" />}
            label={t('common:rrule.period.no_end')}
          />

          {/* End after X occurrences */}
          <Box display="flex" alignItems="center">
            <FormControlLabel
              value={END_TYPES.COUNT}
              control={<Radio size="small" />}
              label={t('common:rrule.period.after')}
              sx={{ mr: 0 }}
            />
            <TextField
              type="number"
              value={count}
              onChange={(e) => onCountChange(Math.max(1, parseInt(e.target.value) || 1))}
              slotProps={{ htmlInput: { min: 1, style: { textAlign: 'center' } } }}
              size="small"
              sx={{ width: 70, mx: 1 }}
              disabled={endType !== END_TYPES.COUNT}
            />
            <Typography color={endType !== END_TYPES.COUNT ? 'text.disabled' : 'text.primary'}>
              {t('common:rrule.period.occurrences')}
            </Typography>
          </Box>

          {/* End by date */}
          <Box display="flex" alignItems="center" mt={1}>
            <FormControlLabel
              value={END_TYPES.UNTIL}
              control={<Radio size="small" />}
              label={t('common:rrule.period.until')}
              sx={{ mr: 0 }}
            />
            <>
              <DatePicker
                value={until}
                onChange={(newValue) => onUntilChange(newValue)}
                disabled={endType !== END_TYPES.UNTIL}
                slotProps={{
                  textField: {
                    size: 'small',
                    sx: { ml: 1, width: 180 },
                  },
                }}
              />
            </>
          </Box>
        </RadioGroup>
      </CardContent>
    </Card>
  );
}
